export default {"src":"/_next/static/media/eye-show.98446828.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};